import { AES, enc } from "crypto-js";
import { VERSION_KEY, LOCAL_STORAGE_PREFIX, LOCAL_STORAGE_KEY } from './../constants/constants';

const secretKey = LOCAL_STORAGE_KEY;
const prefix = LOCAL_STORAGE_PREFIX;

class StoreClass {
  get(key) {
    const item = localStorage.getItem(prefix + '.' + key);
    if(item && key !== VERSION_KEY){
      const value = AES.decrypt(item, secretKey).toString(enc.Utf8);
      return (value) ? JSON.parse(value) : value;
    }
    else{
      return item;
    }
  }

  set(key, value) {
    if (value && key !== VERSION_KEY) {
      localStorage.setItem(prefix + '.' + key, AES.encrypt(JSON.stringify(value), secretKey).toString());
    }
    else {
      localStorage.setItem(prefix + '.' + key, value);
    }
  }

  remove(key) {
    localStorage.removeItem(prefix + '.' + key);
  }

  clearAll() {
    localStorage.clear();
  }

  getUserToken() {
    const configData = this.get('configdata');
    return configData.USERTOKEN;
  }

  getUID() {
    const configData = this.get('configdata');
    return configData.UID;
  }


}

export default new StoreClass();
